import { createContext, useContext } from 'react'
import type { WizardStep } from '../../../Model/OrderWizard/OrderWizardDraft.ts'

/** Opens a step; `before` runs only once the step is really left. */
export type SelectStep = (step: WizardStep, before?: () => void) => void

export const StepSelectContext = createContext<SelectStep | undefined>(undefined)

/** Opens a step the way the stepper does, asking first when leaving would drop unapplied pool changes. */
export const useStepSelect = (): SelectStep | undefined => useContext(StepSelectContext)
